import Vue from 'vue'
import elDragDialog from './el-drag-dialog/index'

Vue.use(elDragDialog)
